import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import React from "react";
import module from "./GridItemText.module.css";

const GridItemText = ({
  label,
  defaultValue,
  value,
  placeholder,
  xs = 6,
  type = null,
  name = null,
  onChange = null,
  onBlur = null,
  isLoading = false,
  error = null,
  disabled = false,
  notRequired = false,
  helperText = null,
}) => (
  <Grid item xs={xs} sx={{ textAlign: "left", marginBottom: "24px" }}>
    <label className={module.label}>{label}</label>
    {!notRequired && <span className={module.labelRequire}>*</span>}
    <TextField
      variant="outlined"
      fullWidth
      sx={{ marginTop: "8px" }}
      defaultValue={defaultValue}
      placeholder={placeholder}
      type={type}
      id={name}
      name={name}
      required={!notRequired}
      error={!!error}
      helperText={error || helperText}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled || isLoading}
      {...(value && { value })}
      InputProps={{
        startAdornment: isLoading && (
          <InputAdornment position="start">
            <CircularProgress color="success" size={20} />
          </InputAdornment>
        ),
      }}
    />
  </Grid>
);

export default GridItemText;
